import type { RiskIndicatorName } from '@/domains/shared';
import type { ComponentType } from 'react';
import type { IconBaseProps } from 'react-icons';
import {
  MdAssessment,
  MdDateRange,
  MdPayments,
  MdPeople,
  MdWarning,
} from 'react-icons/md';

export interface RiskConfigUI {
  label: RiskIndicatorName;
  colorBg: string;
  colorText: string;
  colorBorder: string;
  icon: ComponentType<IconBaseProps>;
}

export const RISK_LEVEL_UI = {
  bajo: 'bg-green-400 text-black',
  medio: 'bg-yellow-400 text-black',
  alto: 'bg-red-400 text-black',
} as const;

// Configuración específica de UI con colores CSS para filtros de riesgo
export const RISK_DATA_UI: RiskConfigUI[] = [
  {
    label: 'asistencia',
    colorBg: 'bg-flame',
    colorText: 'text-flame',
    colorBorder: 'border-flame',
    icon: MdDateRange,
  },
  {
    label: 'nota',
    colorBg: 'bg-magna-cum',
    colorText: 'text-magna-cum',
    colorBorder: 'border-magna-cum',
    icon: MdAssessment,
  },
  {
    label: 'beneficio',
    colorBg: 'bg-blue-bikini',
    colorText: 'text-blue-bikini',
    colorBorder: 'border-blue-bikini',
    icon: MdPayments,
  },
  {
    label: 'social',
    colorBg: 'bg-master-nacho',
    colorText: 'text-master-nacho',
    colorBorder: 'border-master-nacho',
    icon: MdPeople,
  },
  {
    label: 'otro',
    colorBg: 'bg-jubilant-maedow',
    colorText: 'text-jubilant-maedow',
    colorBorder: 'border-jubilant-maedow',
    icon: MdWarning,
  },
];
